/* Jardin Flamingo — AJAX quick add. Uses Shopify's cart API; no jQuery. */
(function () {
  // Guard: the script is referenced by more than one section, and two identical
  // <script src> tags both execute. Run the IIFE body only once.
  if (window.__jfQuickAddLoaded) return;
  window.__jfQuickAddLoaded = true;

  function refreshCartCount(count) {
    document.querySelectorAll('.jf-cart-count').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function bind(wrapper) {
    if (wrapper.dataset.jfBound === 'true') return; // no duplicate submissions
    wrapper.dataset.jfBound = 'true';

    var form = wrapper.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn = form.querySelector('button[name="add"]');
      var err = form.querySelector('[data-jf-qa-error]');
      if (err) err.hidden = true;

      // Hard stop on double-submit.
      if (btn && btn.dataset.loading === 'true') return;
      if (btn) { btn.dataset.loading = 'true'; btn.setAttribute('aria-disabled', 'true'); }

      var body = new FormData(form);
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.dataset.id) body.append('sections', drawer.dataset.id);

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            if (err) { err.textContent = data.description || data.message; err.hidden = false; }
            return;
          }
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
          } else {
            fetch(window.routes.cart_url + '.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) { refreshCartCount(cart.item_count); });
          }
          document.dispatchEvent(new CustomEvent('jf:cart:added'));
        })
        .catch(function () {
          if (err) {
            err.textContent = (window.cartStrings && window.cartStrings.error) || 'Error';
            err.hidden = false;
          }
        })
        .finally(function () {
          if (btn) { btn.dataset.loading = 'false'; btn.removeAttribute('aria-disabled'); }
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-jf-quick-add]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
